import stores from '~/common/stores/stores.js';

export default () => {
    const {
        FirstName,
        LastName,
        Email,
        PhoneNumber,
        JobTitle,
        Password,
        IsNewsletter,
        CompanySize
    } = stores.formsStore;

    const wrapper = document.querySelector('#trialFormWrapper'),
        productTrialSettingId = wrapper ? wrapper.dataset.trialSetting : '';

    const trialObj = {
        productTrialSettingId: productTrialSettingId,
        firstName: FirstName,
        lastName: LastName,
        email: Email,
        phone: PhoneNumber,
        jobTitle: JobTitle,
        password: Password,
        optOut: !IsNewsletter,
        companySize: CompanySize
    };

    return trialObj;
};
